export default Object.freeze({
  EightWeekBlock: '8WK',
  FourWeekBlock: '4WK',
  BusinessAsUsual: 'BAU'
})
